module.exports = __webpack_public_path__ + "img/mobileTheme.4a63138a.svg";